import React from "react";

import { useNavigate, useTranslation } from "utils";

import { CTACard, Icon } from "components";

export const CropSplitCard = ({ fieldId }) => {
  const { t } = useTranslation("modules");
  const navigate = useNavigate();

  return (
    <CTACard ctaIcon="klim/field-split" ctaText={t("cropSplitCard.ctaTitle")} showCTA onCtaClick={() => navigate(`/farm/field/${fieldId}?showFieldDrawer=1`)}>
      <Icon iconName="tabler/trees" size="m" />
      <h5>{t("cropSplitCard.title")}</h5>
      <p>{t("cropSplitCard.explainer")}</p>
      <p className="orange-text">{t("cropSplitCard.warning")}</p>
    </CTACard>
  );
};
